import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import style from './page-layout.module.less';

const TitleSection = ({ children = null, className = '' }) => (
  <div className={classnames(style['title-section'], className)}>{children}</div>
);

TitleSection.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default TitleSection;
